import type { Template } from "@/types";

export const SQ_06_H6_V0: Template[] = [
    {
        id: "sq-06-h6v0-01",
        name: "SQ 01 - H6V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h6_v0_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 43, y: 51, width: 631, height: 408, rotation: 0, imageRotation: 0 },
            { id: "2", x: 43, y: 467, width: 312, height: 199, rotation: 0, imageRotation: 0 },
            { id: "3", x: 363, y: 467, width: 311, height: 199, rotation: 0, imageRotation: 0 },
            { id: "4", x: 760, y: 51, width: 312, height: 199, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1080, y: 51, width: 311, height: 199, rotation: 0, imageRotation: 0 },
            { id: "6", x: 760, y: 258, width: 631, height: 408, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h6v0-02",
        name: "SQ 02 - H6V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h6_v0_02.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 203, y: 51, width: 311, height: 200, rotation: 0, imageRotation: 0 },
            { id: "2", x: 203, y: 259, width: 311, height: 200, rotation: 0, imageRotation: 0 },
            { id: "3", x: 203, y: 467, width: 311, height: 199, rotation: 0, imageRotation: 0 },
            { id: "4", x: 920, y: 51, width: 311, height: 200, rotation: 0, imageRotation: 0 },
            { id: "5", x: 920, y: 259, width: 311, height: 200, rotation: 0, imageRotation: 0 },
            { id: "6", x: 920, y: 467, width: 311, height: 199, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h6v0-03",
        name: "SQ 03 - H6V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h6_v0_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 172, y: 0, width: 373, height: 234, rotation: 0, imageRotation: 0 },
            { id: "2", x: 172, y: 242, width: 373, height: 234, rotation: 0, imageRotation: 0 },
            { id: "3", x: 172, y: 484, width: 373, height: 233, rotation: 0, imageRotation: 0 },
            { id: "4", x: 889, y: 0, width: 373, height: 234, rotation: 0, imageRotation: 0 },
            { id: "5", x: 889, y: 242, width: 373, height: 234, rotation: 0, imageRotation: 0 },
            { id: "6", x: 889, y: 484, width: 373, height: 233, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h6v0-04",
        name: "SQ 04 - H6V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h6_v0_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 40, y: 116, width: 358, height: 239, rotation: 0, imageRotation: 0 },
            { id: "2", x: 40, y: 363, width: 358, height: 238, rotation: 0, imageRotation: 0 },
            { id: "3", x: 406, y: 116, width: 747, height: 485, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1161, y: 116, width: 233, height: 157, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1161, y: 281, width: 233, height: 156, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1161, y: 445, width: 233, height: 156, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h6v0-05",
        name: "SQ 05 - H6V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h6_v0_05.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 44, y: 50, width: 630, height: 407, rotation: 0, imageRotation: 0 },
            { id: "2", x: 44, y: 465, width: 311, height: 202, rotation: 0, imageRotation: 0 },
            { id: "3", x: 363, y: 465, width: 311, height: 202, rotation: 0, imageRotation: 0 },
            { id: "4", x: 856, y: 141, width: 439, height: 286, rotation: 0, imageRotation: 0 },
            { id: "5", x: 856, y: 434, width: 216, height: 142, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1079, y: 434, width: 216, height: 142, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h6v0-06",
        name: "SQ 06 - H6V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h6_v0_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 117, width: 713, height: 483, rotation: 0, imageRotation: 0 },
            { id: "2", x: 721, y: 117, width: 713, height: 357, rotation: 0, imageRotation: 0 },
            { id: "3", x: 721, y: 482, width: 173, height: 118, rotation: 0, imageRotation: 0 },
            { id: "4", x: 902, y: 482, width: 172, height: 118, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1082, y: 482, width: 172, height: 118, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1262, y: 482, width: 172, height: 118, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h6v0-07",
        name: "SQ 07 - H6V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h6_v0_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 74, width: 713, height: 569, rotation: 0, imageRotation: 0 },
            { id: "2", x: 721, y: 74, width: 425, height: 281, rotation: 0, imageRotation: 0 },
            { id: "3", x: 721, y: 363, width: 425, height: 280, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1154, y: 74, width: 280, height: 185, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1154, y: 267, width: 280, height: 184, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1154, y: 459, width: 280, height: 184, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h6v0-08",
        name: "SQ 08 - H6V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h6_v0_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 74, width: 713, height: 569, rotation: 0, imageRotation: 0 },
            { id: "2", x: 721, y: 74, width: 280, height: 185, rotation: 0, imageRotation: 0 },
            { id: "3", x: 721, y: 267, width: 280, height: 184, rotation: 0, imageRotation: 0 },
            { id: "4", x: 721, y: 459, width: 280, height: 184, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1009, y: 74, width: 425, height: 281, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1009, y: 363, width: 425, height: 280, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h6v0-09",
        name: "SQ 09 - H6V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h6_v0_09.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 194, width: 470, height: 329, rotation: 0, imageRotation: 0 },
            { id: "2", x: 478, y: 194, width: 235, height: 161, rotation: 0, imageRotation: 0 },
            { id: "3", x: 478, y: 363, width: 235, height: 160, rotation: 0, imageRotation: 0 },
            { id: "4", x: 721, y: 194, width: 235, height: 161, rotation: 0, imageRotation: 0 },
            { id: "5", x: 721, y: 363, width: 235, height: 160, rotation: 0, imageRotation: 0 },
            { id: "6", x: 964, y: 194, width: 470, height: 329, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-06-h6v0-10",
        name: "SQ 10 - H6V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h6_v0_10.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 194, width: 235, height: 160, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 362, width: 235, height: 161, rotation: 0, imageRotation: 0 },
            { id: "3", x: 242, y: 194, width: 471, height: 329, rotation: 0, imageRotation: 0 },
            { id: "4", x: 721, y: 194, width: 470, height: 329, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1199, y: 194, width: 235, height: 160, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1199, y: 362, width: 235, height: 161, rotation: 0, imageRotation: 0 }
        ],
    },
];

